import React from 'react';
import { TopActionBar } from './TopActionBar/TopActionBar';
import { Flex } from './antd';
import { ButtonLink } from './ButtonLink/ButtonLink';

export const ViewMigrationsTopBar = () => {
    return (
        <TopActionBar>
            <Flex gap="small">
                <ButtonLink route="/migration_list" text="Active" />
                <ButtonLink route="/scheduled_migrations" text="Scheduled" />
                <ButtonLink route="/archived_migrations" text="Archived" />
            </Flex>
        </TopActionBar>
    );
};
